import { useState, useEffect, useCallback } from 'react';
import { Typography, Button, Paper} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import useMediaQuery from '@mui/material/useMediaQuery';
import Swal from 'sweetalert2';
import MiTabla from '../../components/plantilla/tabla/MiTabla';
import BtnAcciones from '../../components/plantilla/tabla/BtnAcciones';

// Iconos
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CrearEditarModal from './modales/CrearEditarMetas';

const Metas = () => {

    const isNonMobile = useMediaQuery("(min-width:600px)");

    const [data, setData] = useState([]);
    const [selected, setSelected] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);


    const handleOpenModal = (meta = null) => {
        setSelected(meta);
        setIsEditing(!!meta);
        setModalOpen(true);
    };

    const handleDelete = useCallback(async (id) => {
        try {
            Swal.fire({
                title: '¿Estás seguro de eliminar esta meta?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let { data } = await myApi.delete(`/cargasFuel/deleteMeta/${id}`);

                    if (data.success) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Meta eliminada',
                        });

                        setData(prevData => prevData.filter(meta => meta.id !== id));
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al eliminar la meta',
                        });
                    }
                }
            });
            
        } catch (error) {
            console.error('Error deleting goal:', error);
        }
    }, []);

    const handleEdit = useCallback(async (goalRow) => {
        handleOpenModal(data.find(meta => meta.id === goalRow.id));
        setIsEditing(true);
        setSelected(goalRow);
        
    }, []);

    const columns = [
        { field: 'class', headerName: 'CLASS',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'millas', headerName: 'MILLAS',
            flex: 1,
            type: 'number',
            headerAlign: "center",
            align: "center",
        },
        { field: 'mpg', headerName: 'MPG',
            flex: 1,
            type: 'number',
            headerAlign: "center",
            align: "center",
        },
        { field: 'cruise_ctrl_percent', headerName: 'CRUISE CONTROL %',
            flex: 1,
            headerAlign: "center",
            align: "center",
            type: 'number',
        },
        { field: 'idle_percent', headerName: 'IDLE %',
            flex: 1,
            headerAlign: "center",
            align: "center",
            type: 'number',
        },
        { field: 'top_gear_percent', headerName: 'TOP GEAR %',
            flex: 1,
            headerAlign: "center",
            align: "center",
            type: 'number',
        },
        {
            field: 'actions',
            headerName: 'ACCIONES',
            type: 'actions',
            width: 150,
            getActions: (params) => [
                <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                    onClick={() => handleEdit(params.row)}
                />,
                <BtnAcciones
                    icon={<DeleteIcon />}
                    label="Eliminar"
                    onClick={() => handleDelete(params.row.id)}
                />
            ],
        }
    ];

    const fetch = async () => 
    {
        try 
        {
            const response = await myApi.get('/cargasFuel/getGoals');
            if(response.data.success)
                setData(response.data.data);
            else
                setData([]);
        } 
        catch(error) 
        {
            console.error('Error fetching goals:', error);
        }
    };

    const handleRowClick = (params) => {

    }

    useEffect(() => {
        fetch();
    }, []);

    return (
        <Paper sx={{padding: 2}}>
            <Grid container>
                <Grid size={{ xs: 12, md: 8 }}>
                    <Typography variant="h4" fontWeight="bold" marginBottom={2}>
                        Metas
                    </Typography>
                </Grid>
                <Grid item size={{ xs: 12, md: 4 }}
                    sx={{
                        display: 'flex',
                        justifyContent: isNonMobile ? 'flex-end' : 'start'
                    }}>
                    <Button
                        variant="contained"
                        startIcon={<AddCircleIcon />}
                        onClick={() => handleOpenModal()}
                        sx={{ backgroundColor: 'black', marginBottom: 1 }}
                    >
                        Agregar
                    </Button>
                </Grid>
                {/** {LISTA DE OPERADORES} */}
                <Grid size={12}
                    marginTop={1}>
                    <MiTabla
                        columns={columns}
                        data={data}
                        rowClick={handleRowClick}
                    />
                </Grid>
                {/* {MODAL EDITAR/CREAR} */}
                <CrearEditarModal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    refresh={fetch}
                    meta={selected}
                    isEditing={isEditing}
                />
            </Grid>
        </Paper>

    )

}

export default Metas